var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.usuario.id_group == '11')?_c('vs-card',[_c('agendaCapacitaciones')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }